module.exports = __webpack_public_path__ + "static/media/home-discover-before.27a2cd4a.svg";